import React from "react";
import PropTypes from "prop-types";
import clsx from "clsx";

/** An aggregate of many media cards */
const CardList = props => {
  const { className, children, ...other } = props;

  return (
    <ul
      className={clsx(
        "em-c-card-list",
        "em-l-grid",
        "em-l-grid--3up",
        className
      )}
      {...other}
    >
      {React.Children.toArray(children).map(child => (
        <li className="em-c-card-list__item em-l-grid__item" key={child.key}>
          {child}
        </li>
      ))}
    </ul>
  );
};

CardList.propTypes = {
  /** Additional css classNames to append to the outer element */
  className: PropTypes.string,
  /** React component children */
  children: PropTypes.node
};

CardList.defaultProps = {
  className: "",
  children: null
};

export default CardList;
